
import { en } from './en/common';
import { ko } from './ko/common';
import { zh } from './zh/common';  
import { ja } from './ja/common';

const messages = {
  en: {
    translation: en
  },
  ko: {
    translation: ko
  },
  zh: {
    translation: zh
  },
  ja: {
    translation: ja
  }
};

export default messages;
